import { render, staticRenderFns } from "./ListScientific_consultant.vue?vue&type=template&id=4c9fee00&scoped=true"
import script from "./ListScientific_consultant.vue?vue&type=script&lang=js"
export * from "./ListScientific_consultant.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c9fee00",
  null
  
)

export default component.exports